import React from 'react';
import cx from 'classnames';

import './BulletedList.css';

export type BulletedListProps = {
  children: JSX.Element | JSX.Element[];
  className: string;
  color: 'pink' | 'teal' | 'white';
};

export const BulletedList = ({
  children,
  className,
  color = 'pink',
}: BulletedListProps): JSX.Element => {
  const classes = cx(
    'bulleted-list',
    { 'bulleted-list--pink': color === 'pink' },
    { 'bulleted-list--teal': color === 'teal' },
    { 'bulleted-list--white': color === 'white' },
    className
  );
  return <ul className={classes}>{children}</ul>;
};

export default BulletedList;
